module.exports = __webpack_public_path__ + "258a21c394d4dddc0ca76bb3385f4434.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-4.png
// module id = 2162
// module chunks = 0